import 'css-chunksrc/client/scenes/workloads/graph/styles.scss';export default {
  "graph": "_graph_vxct8_1",
  "main": "_main_vxct8_7",
  "elementsOverlay": "_elementsOverlay_vxct8_13",
  "element": "_element_vxct8_13"
};